/* eslint-disable */

import { APIClient } from "./_api";

const endpoint = "/Country";

export function getCountry() {
  return APIClient.get(`${endpoint}`);
}

export function getRoles() {
  return APIClient.get(`/Role`);
}
export function getRolesCount() {
  return APIClient.get(`/Role/count`);
}

export function getStatus() {
  return APIClient.get(`/OrderStatus`);
}

export function changeStatus({ id, statusId }) {
  return APIClient.put(`/Order/OrderStatus/${id}`, { statusId });
}

export function updateStatus({ id }) {
  return APIClient.post(`/Order/OrderStatus/back`, {
    orderId: id,
  });
}

export function getAllValidStatus(id) {
  return APIClient.get(`/OrderStatus/valid/${id}`);
}
